import React from 'react';
import Agradecimento from '../components/Agradecimento';
import Created from '../components/Created';

export default function AgradecimentoPage() {
  return (
    <div className="flex h-dvh max-h-dvh flex-col overflow-hidden bg-gray-600">
      <Agradecimento />
      <Created />
    </div>
  );
}
